export var ClassNames = /*#__PURE__*/function (ClassNames) {
  ClassNames["container"] = "live-chat-loader-placeholder";
  return ClassNames;
}({});